import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnchor, faSwimmer, faSnowflake, faLifeRing } from '@fortawesome/free-solid-svg-icons';
import { faBluetoothB } from '@fortawesome/free-brands-svg-icons';

const BoatFeatureBar = () => {
  const features = [
    { icon: faAnchor, label: 'Crew' },
    { icon: faBluetoothB, label: 'Bluetooth' },
    { icon: faSwimmer, label: 'Water Toys' },
    { icon: faSnowflake, label: 'Cooler with Ice' },
    { icon: faLifeRing, label: 'Life Jackets' }
  ];

  return (
    <div className="boat-feature-bar">
        <div className="boat-feature-bar__inner">
            {features.map((feature, index) => (
                <div key={index} className="boat-feature-bar__item">
                    <FontAwesomeIcon icon={feature.icon} className="boat-feature-bar__icon" />
                    <span className="boat-feature-bar__label">{feature.label}</span>
                </div>
            ))}
        </div>
    </div>
  );
};

export default BoatFeatureBar; 